import { Seo } from '../../components/seo';

function SettingsPage() {
  return (
    <Seo title="Settings" />
  );
}

export default SettingsPage;
